<template>
    <div>
        <div
            class="d-block d-md-flex"
            :class="{
                'isDisplayRepeat' : isDisplayRepeat,
                'doctorMenuDoctorInfoClickable' : withDoctorProfileModal,
                'align-items-start' : alignDoctorImage === 'start',
                'align-items-center' : alignDoctorImage === 'center'
            }"
            @click="openModalDoctorProfile">
            <div class="doctorMenuDoctorImageWrapper">
                <div class="doctorMenuDoctorImage">
                    <img
                        v-if="doctor && doctor.presigned_url"
                        :src="doctor.presigned_url">
                    <img
                        v-else
                        src="/images/common/profile_default.svg">
                </div>
                <div
                    v-if="withDoctorProfileModal"
                    class="doctorMenuDoctorDetailIcon d-flex justify-content-center align-items-center">
                    <b-icon-zoom-in/>
                </div>
            </div>

            <div class="doctorMenuDoctorDetail">
                <div class="doctorMenuDoctorName">
                    <template v-if="doctor !== null">
                        <span>{{ doctor.full_name }}</span>
                        <span v-if="!isStaff">医師</span>
                    </template>
                    <template v-else>
                        <span class="d-block mt-4 pt-3"></span>
                        <span class="text-muted">退会済の医師</span>
                    </template>
                </div>

                <div v-if="doctor !== null">
                    <div>
                        <div
                            v-for="course in doctor.medical_courses"
                            class="doctorMenuDoctorMedicalCourse">
                            {{ course.name }}
                        </div>
                    </div>
                    <div class="mt-1 pt-1">
                        <div
                            v-for="label in doctor.doctor_labels"
                            class="doctorMenuDoctorLabel">
                            {{ label.name }}
                        </div>
                    </div>
                    <div>
                        <div>
                            <div
                                v-if="earlySchedule !== null && earlySchedule !== void(0)"
                                class="doctorMenuEarlySchedule mb-1">
                                <span>最短&nbsp;{{ formattedEarlySchedule }}&nbsp;{{ $locale.consultation_host }}可能</span>
                            </div>
                        </div>
                        <div>
                            <div
                                v-if="withRecentlyConsultationDate && recentlyConsultationDate !== null"
                                class="recentlyConsultationDate">
                                {{ `前回は${recentlyConsultationDate}に${$locale.consultation_guest}しました` }}
                            </div>
                        </div>
    <!--                    <div class="mt-2 ml-lg-2">-->
    <!--                        <div class="d-flex weekOfDaysHeader">-->
    <!--                            <div>日</div>-->
    <!--                            <div>月</div>-->
    <!--                            <div>火</div>-->
    <!--                            <div>水</div>-->
    <!--                            <div>木</div>-->
    <!--                            <div>金</div>-->
    <!--                            <div>土</div>-->
    <!--                        </div>-->
    <!--                        <div class="d-flex weekOfDaysContent">-->
    <!--                            <div>{{ scheduleTimeIcon(0) }}</div>-->
    <!--                            <div>{{ scheduleTimeIcon(1) }}</div>-->
    <!--                            <div>{{ scheduleTimeIcon(2) }}</div>-->
    <!--                            <div>{{ scheduleTimeIcon(3) }}</div>-->
    <!--                            <div>{{ scheduleTimeIcon(4) }}</div>-->
    <!--                            <div>{{ scheduleTimeIcon(5) }}</div>-->
    <!--                            <div>{{ scheduleTimeIcon(6) }}</div>-->
    <!--                        </div>-->
    <!--                    </div>-->
                    </div>
                    <div v-if="!isIntroductionTypeAll && isIntroductionTypeHistory">
                        <div class="mt-2">
                            <div class="doctorMenuDoctorHistoryTitle">略歴</div>
                            <template v-if="doctor.doctor_histories.length > 0">
                                <div
                                    v-for="history in doctor.doctor_histories"
                                    class="doctorMenuDoctorHistory d-flex">
                                    <span>{{ history.accrual_year }}年　</span><!--
                                 --><span>{{ history.content }}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div>-</div>
                            </template>
                        </div>
                        <div class="mt-2 pt-1">
                            <div class="doctorMenuDoctorLicenseTitle">資格・所属学会等</div>
                            <template v-if="doctor.doctor_licenses.length > 0">
                                <div
                                    v-for="license in doctor.doctor_licenses"
                                    class="doctorMenuDoctorLicense">
                                    <span>{{ license.content }}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div>-</div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isIntroductionTypeAll">
            <div
                class="descriptionWrapper"
                :class="{ 'descriptionWrapperExtended' : isShowDoctorIntroduction }">
                <div v-if="hasIntroduction">
                    <div class="description">{{ doctor.introduction }}</div>
                    <hr class="divide">
                </div>
                <div class="mt-2">
                    <div class="doctorMenuDoctorHistoryTitle">略歴</div>
                    <template v-if="doctor.doctor_histories.length > 0">
                        <div
                            v-for="history in doctor.doctor_histories"
                            class="doctorMenuDoctorHistory d-flex">
                            <span>{{ history.accrual_year }}年　</span><!--
                                 --><span>{{ history.content }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div>-</div>
                    </template>
                </div>
                <div class="mt-2 pt-1">
                    <div class="doctorMenuDoctorLicenseTitle">資格・所属学会等</div>
                    <template v-if="doctor.doctor_licenses.length > 0">
                        <div
                            v-for="license in doctor.doctor_licenses"
                            class="doctorMenuDoctorLicense">
                            <span>{{ license.content }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div>-</div>
                    </template>
                </div>
            </div>
            <div
                v-if="withExtender && isShowDoctorIntroduction === false"
                @click="isShowDoctorIntroduction = true"
                class="descriptionExtender">
                ▼&nbsp;全文を表示
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'

    export default {
        props: {
            doctor: {
                type: Object|null,
                default: null,
            },
            user: {
                type: Object|null,
                default: null,
            },
            userType: {
                type: String,
                default: 'user',
            },
            earlySchedule: {
                type: String|null,
                default: null,
            },
            withDoctorProfileModal: {
                type: Boolean,
                default: false,
            },
            withRecentlyConsultationDate: {
                type: Boolean,
                default: false,
            },
            withExtender: {
                type: Boolean,
                default: false,
            },
            doctorIntroductionType: {
                type: String,
                default: 'none',
            },
            alignDoctorImage: {
                type: String,
                default: 'start',
            },
            isDisplayRepeat: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                isShowDoctorIntroduction: true,
            }
        },

        computed: {
            /**
             * スタッフ判定
             *
             * @return {boolean}
             */
            isStaff: function () {
                return this.doctor && this.doctor.full_name.includes('スタッフ')
            },

            /**
             * 最短予約可能日時を返す
             *
             * @returns {string|null}
             */
            formattedEarlySchedule: function () {
                if (!this.earlySchedule || !this.user) {
                    return null
                }
                return this.helper
                    .userTime(this.earlySchedule, this.user.timezone)
                    .format('M月D日 (ddd) ah:mm〜')
            },

            // scheduleTimes: function () {
            //     const user = this.$store.state.reservation.user
            //     const times = [0, 0, 0, 0, 0, 0, 0]
            //
            //     const jstTimeNow = this.helper.jstTimeNow()
            //     const dateFormat = jstTimeNow.format('YYYY-MM-DD')
            //
            //     this.doctor.schedules.forEach((schedule) => {
            //         const jstSt = this.helper.jstTime(`${dateFormat} ${schedule.start_time}`, 'Asia/Tokyo')
            //         const jstEd = this.helper.jstTime(`${dateFormat} ${schedule.end_time}`, 'Asia/Tokyo')
            //
            //         // scheduleの曜日に合わせる
            //         const diff = 7 - jstSt.day()
            //         jstSt.add(diff + schedule.day, 'days')
            //         jstEd.add(diff + schedule.day, 'days')
            //
            //         const st = this.helper.userTime(jstSt.format('YYYY-MM-DD HH:mm:ss'), this.user.timezone)
            //         const ed = this.helper.userTime(jstEd.format('YYYY-MM-DD HH:mm:ss'), this.user.timezone)
            //
            //         while (st.isBefore(ed)) {
            //             const day = st.day()
            //             times[day] += 15
            //             st.add(15, 'minutes')
            //         }
            //     })
            //
            //     return times
            // },

            /**
             * 会員のタイムゾーンを返す
             *
             * @return {string}
             */
            userTimezone: function () {
                return this.user ? this.user.timezone : 'Asia/Tokyo'
            },

            /**
             * 直近の相談日を取得
             *
             * @return {string|null}
             */
            recentlyConsultationDate: function () {
                if (this.userType !== 'user') return null

                const consultations = this.$store.state.userConsultations.recentlyConsultations

                const finishedConsultation = consultations.find((consultation) => {
                    return this.doctor.id === consultation.doctor_id
                        && consultation.status === constants.consultations.finished
                })

                if (finishedConsultation) {
                    return this.helper.userTime(finishedConsultation.start_time, this.userTimezone).format('YYYY年M月D日')
                }
                return null
            },

            isIntroductionTypeAll: function () {
                return this.doctorIntroductionType === 'all'
            },

            isIntroductionTypeHistory: function () {
                return this.doctorIntroductionType === 'history'
            },

            hasIntroduction: function () {
                return this.isIntroductionTypeAll && this.doctor && this.doctor.introduction !== null
            },
        },

        created: function () {
            if (this.withExtender) {
                this.isShowDoctorIntroduction = false
            }
        },

        methods: {
            /**
             * 医師プロフィールモーダル表示
             */
            openModalDoctorProfile: function () {
                if (!this.withDoctorProfileModal || !this.doctor) {
                    return
                }

                this.pushAnalyticsDataLayerShowProfileFromDoctorMenus()

                const options = {
                    earlySchedule: this.earlySchedule,
                    canReserve: true,
                }

                // 親コンポーネント側に <doctor-profile-modal> を配置すること
                bus.$emit('open-modal-doctor-profile', this.doctor.id, options)
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayerShowProfileFromDoctorMenus: function () {
                if (this.$locale.type !== 'consul'|| !this.doctor) {
                    return
                }

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__showProfileFromDoctorMenus',
                    doctorId: this.doctor.id,
                })
            },

            // /**
            //  * 曜日ごとの空き具合アイコン表示
            //  *
            //  * @param {number} weekday
            //  * @return {string}
            //  */
            // scheduleTimeIcon: function (weekday) {
            //     const time = this.scheduleTimes[weekday]
            //
            //     if (time >= 360) {
            //         return '◎'
            //     } else if (time >= 180) {
            //         return '○'
            //     } else if (time > 0) {
            //         return '△'
            //     } else {
            //         return '×'
            //     }
            // },
        },
    }
</script>

<style lang="scss" scoped>
.isDisplayRepeat {
    @media screen and (max-width: 1299px) {
        display: block !important;
    }
}

.doctorMenuDoctorInfoClickable {
    cursor: pointer;
    transition: opacity 0.1s ease-in-out;

    &:hover {
        opacity: 0.7;
    }
}

.doctorMenuDoctorImageWrapper {
    position: relative;

    @media screen and (max-width: 1299px) {
        margin-bottom: 10px;
    }

    .doctorMenuDoctorImage {
        position: relative;
        overflow: hidden;
        width: 130px;
        min-width: 130px;
        height: 130px;
        border-radius: 50%;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }

    .doctorMenuDoctorDetailIcon {
        position: absolute;
        right: 4px;
        bottom: 4px;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 4px solid #F9F9F9;
        background: #487EAF;

        @media screen and (max-width: 767px) {
            right: auto;
            left: 102px;
        }

        svg {
            color: #fff;
            font-size: 16px;
        }
    }
}

.doctorMenuDoctorName {
    color: #2A2E31;
    font-weight: bold;

    span {
        font-size: 22px;

        &:nth-child(2) {
            font-size: 13px;
        }
    }
}

.doctorMenuDoctorDetail {
    margin-left: 20px;

    @media screen and (max-width: 767px) {
        margin-left: 0;
    }
}

.doctorMenuDoctorMedicalCourse {
    display: inline-block;
    color: #7D868D;
    font-size: 14px;
    font-feature-settings: 'palt';
    line-height: 1;

    &::after {
        content: '、';
    }

    &:last-child {
        &::after {
            display: none;
        }
    }
}

.doctorMenuDoctorLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 12px;
    color: #B49834;
    font-size: 13px;
    border: 1px solid #EDECDC;
    background-color: #F7F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.doctorMenuEarlySchedule {
    display: inline-block;
    padding: 2px 10px;
    color: #CF798A;
    text-align: center;
    font-size: 12px;
    background-color: #FBEFF2;
    border: 1px solid #EBC6CD;
    border-radius: 6px;
    box-sizing: border-box;
}

.weekOfDaysHeader {
    div {
        width: 25px;
        padding-bottom: 3px;
        color: #7D868D;
        font-size: 13px;
        font-weight: bold;
        line-height: 1;
        text-align: center;
        box-sizing: border-box;

        &:nth-child(1) {
            color: #CE4F54;
        }

        &:nth-child(7) {
            color: #5581AE;
        }
    }
}

.weekOfDaysContent {
    div {
        width: 25px;
        color: #7D868D;
        font-size: 13px;
        font-weight: bold;
        line-height: 1;
        text-align: center;
        box-sizing: border-box;
    }
}

.doctorMenuDoctorHistory {
    color: #757C83;

    > span {
        &:nth-child(1) {
            min-width: 60px;
        }
    }
}

.doctorMenuDoctorHistoryTitle {
    font-weight: bold;
}

.doctorMenuDoctorLicense {
    color: #757C83;
}

.doctorMenuDoctorLicenseTitle {
    font-weight: bold;
}

.descriptionWrapper {
    position: relative;
    height: 56px;
    overflow: hidden;
    margin-top: 15px;
    padding: 15px;
    background-color: #F9F9F9;
    border: 1px solid #EDEDED;
    border-radius: 6px 6px 0 0;
    border-bottom: none;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 100%;
        height: 5px;
        background: #fff;
        box-shadow: 0 -3px 4px #fff;
    }

    &.descriptionWrapperExtended {
        height: auto;
        border-radius: 6px;
        border-bottom: 1px solid #EDEDED;

        &::after {
            display: none;
        }
    }
}

.description {
    overflow: hidden;
    color: #757C83;
    font-size: 15px;
    line-height: 24px;
    white-space: pre-wrap;
}

.descriptionExtender {
    position: relative;
    left: -2px;
    margin-top: 6px;
    color: #7D868D;
    font-size: 15px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
}

.recentlyConsultationDate {
    display: inline-block;
    padding: 2px 10px;
    color: #7D868D;
    text-align: center;
    font-size: 12px;
    background-color: #eaeaea;
    border: 1px solid #c7c7c7;
    border-radius: 6px;
    box-sizing: border-box;
}
</style>
